import { Component, computed, inject, input, signal, ViewChild } from '@angular/core';
import { PropertyChargeListViewLocations } from '../../../../core/enums/base.enums';
import { MemberModel } from '../../../../core/models/data/member.model';
import { PropertyChargeListComponent } from '../../../balances/components/property-charge-list/property-charge-list.component';
import { UserSessionService } from '../../../../core/services/user-session.service';
import { ProfileOrganizationScopeService } from '../../../../core/services/authorization/profile-organization-scope.service';
import { CurrencyDisplayPipe } from '../../../../core/pipes/currency/currency.pipe';
import { CurrencyModel } from '../../../../core/models/data/currency.model';
import { PaymentModalComponent } from '../../../../parts/payment-modal/payment-modal.component';
import { TooltipDirective } from '../../../../core/directives/tooltip.directive';
import { PaymentMessagingConstants } from '../../../../core/constants/messaging.constants';

@Component({
  selector: 'ms-member-invoicing',
  imports: [PropertyChargeListComponent, CurrencyDisplayPipe, PaymentModalComponent, TooltipDirective],
  templateUrl: './member-profile-invoicing.component.html'
})
export class MemberProfileInvoicingComponent {
  @ViewChild('chargeList') chargeList?: PropertyChargeListComponent;
  @ViewChild('paymentModal') paymentModal?: PaymentModalComponent;

  public member = input<MemberModel | undefined>(undefined);
  public PropertyChargeListViewLocations = PropertyChargeListViewLocations;
  private profileScope = inject(ProfileOrganizationScopeService, { optional: true });

  // The member's own organization's Stripe status, not the active organization's — this gates the
  // Pay button, and a member profile is reachable for any organization the viewer belongs to.
  // Resolves to false while the scoped settings load, so Pay is never enabled against an
  // organization whose Stripe onboarding state isn't known yet (DEV-2643).
  public isStripeOnboardingComplete = computed(() =>
    ProfileOrganizationScopeService.resolveSettings(this.profileScope, this.userSessionService)?.isStripeOnboardingComplete ?? false);
  public onlinePaymentsDisabledTooltip = PaymentMessagingConstants.PAYMENT_ONLINE_PAYMENTS_DISABLED_TOOLTIP();
  public selectedInvoiceAmount = signal<number>(0);
  public currencyType = signal<CurrencyModel | undefined>(undefined);

  constructor(public userSessionService: UserSessionService) {
  }

  public async payCharges(): Promise<void> {
    const charges = this.chargeList?.buildChargeBulkActionRequest();
    if (!charges) return;

    await this.paymentModal?.open(
      charges,
      this.currencyType()?.code,
      this.selectedInvoiceAmount()
    );
  }

  public onPaymentCompleted(): void {
    this.chargeList?.loadPropertyCharges(false);
  }
}
